module.exports = "/_next/static/images/592bf65c07ef24a4454d03b1f3cfc5ec-Nubank_HickDuarte_58741_lg.jpg";